// extracted by mini-css-extract-plugin
export default {"container":"settings_container__diFOJ","close":"settings_close__75NFX","menu":"settings_menu__FZNTb","logout":"settings_logout__r5MgK"};